// extracted by mini-css-extract-plugin
export default {"root":"lkVbk","icon":"DjwwD"};